import {Component, HostListener, Input} from '@angular/core';
import {FormControl} from '@angular/forms';
import {inputSearchAnimation} from '../folder-selector-dialog.animations';
import {showOpacityAnimation} from '../../../../animations/show-opacity.animation';

@Component({
  selector: 'app-folder-selector-dialog-search-bar',
  templateUrl: './folder-selector-dialog-search-bar.component.html',
  styleUrls: ['./folder-selector-dialog-search-bar.component.scss'],
  animations: [
    showOpacityAnimation,
    inputSearchAnimation
  ]
})
export class FolderSelectorDialogSearchBarComponent {
  @Input() public searchCtrl: FormControl = new FormControl();

  public inputFocus: boolean = false;

  public onInputSearchClear(): void {
    this.searchCtrl.reset();
  }

  public onInputFocusIn(): void {
    this.inputFocus = true;
  }

  public onInputFocusOut(): void {
    this.inputFocus = false;
  }
}
